<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 class="row">{{ "raster-depth.title" | translate }}</h2>
  <div *ngIf="topMenuIcons.length > 0">

    <button mat-raised-button *ngFor="let action of topMenuIcons" [routerLink]="action.routerLink"
      (click)="this[action.clickMethod]()">
      <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
    </button>
  </div>
</div>
<form [formGroup]="detailForm">
  <div fxLayout="column"  style="min-width: 500px;">
    <div fxLayout="row wrap" fxLayoutGap="40px">
      <mat-form-field *ngIf="columnsVisible.get('x')" [ngStyle]="{
            'width.ch': detailForm.controls['x'].value ? detailForm.controls['x'].value.length : 10,
            'min-width.px': 250
          }">
        <mat-label> {{ "raster-depth.location" | translate }} </mat-label>
        <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['x'].value ? detailForm.controls['x'].value.length : 10,
              'min-width.px': 230
            }" [value]="this.coordinatesFormatted" disabled="true" />
      </mat-form-field>
    </div>

    <div *ngIf="dataArrayDepths && dataArrayDepths.data.length > 0  && finished">
    
      <mat-table [dataSource]="dataArrayDepths" class="mat-elevation-z8" style="max-height: 400px;">
        
        <ng-container matColumnDef="rasterName">
          <mat-header-cell *matHeaderCellDef   [style]="headerStyle"> 
            {{ "raster.depth.raster-name" | translate }} 
          </mat-header-cell>
          <mat-cell *matCellDef="let element"  class="m-card-title has_label_on_mobile" [attr.data-label]='("raster.depth.raster-name" | translate) + ":"'>
            {{element.rasterName}} </mat-cell>
          </ng-container>
          
            <ng-container matColumnDef="depth">
            <mat-header-cell *matHeaderCellDef  [style]="headerStyle"> 
              {{ "raster.depth.depth" | translate }} 
            </mat-header-cell>
            <mat-cell *matCellDef="let element"  class="m-card-title has_label_on_mobile" [attr.data-label]='("raster.depth.depth" | translate) + ":"'> 
              {{element.depth}} </mat-cell>
          </ng-container>
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="40px" *ngIf="dataArrayDepths && dataArrayDepths.data.length === 0 && finished">
    <mat-label> {{ "raster-depth.no-depths-found" | translate }} </mat-label>
  </div>
  </div>

</form>